<template>
  <div class="bg-secondary-1 rounded">
    <board :details="contractBoardDetails" header-class="pt-2 px-1" />
    <div class="row ml-4 pl-3 py-3">
      <div class="col-12 col-lg-3">
        <span class="color-gray-6 d-block font-14">
          Servicio / Disciplina:
        </span>
        <span class="font-16 color-black">
          {{ serviceDisciplineName }}
        </span>
      </div>
      <div class="col-12 col-lg-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">
          Número de Contrato:
        </span>
        <span class="font-16 color-black">
          {{ contractInfo.contractNumber | empty }}
        </span>
      </div>
      <div class="col-12 col-lg-3 mt-3 mt-md-0">
        <span class="color-gray-6 d-block font-14">
          Estatus:
        </span>
        <div style="display: flex;">
          <div
            v-if="!hasStatus"
            :class="`bg-${contractStatusColor}`"
            style="height: 15px !important;
                width: 15px !important;
                border-radius: 26px;
                margin-top: 5px;"
          />
          <span class="font-16 color-black" style="padding-left: 5px;">
            {{ contractStatusName | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//lib components
import Board from 'Board';

//constants
import rpContractStatus, {
  rpContractStatusColor,
} from '@/utils/constants/rpContractStatus.js';

export default {
  name: 'GeneralInfo',
  components: {
    Board,
  },
  props: {
    contractInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    serviceDisciplineName() {
      return this.contractInfo.requestServiceDisciplineTypeName
        ? `${this.contractInfo.requestServiceTypeName} - ${this.contractInfo.requestServiceDisciplineTypeName}`
        : this.contractInfo.requestServiceTypeName;
    },
    contractBoardDetails() {
      return [
        [
          {
            label: 'Año Escolar del Contrato:',
            data: this.contractInfo?.academicYear,
            icon: 'fas fa-calendar-alt',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Número de Solicitud:',
            data: this.contractInfo?.requestNumber,
            icon: 'fas fa-file-invoice',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Nombre del Estudiante:',
            data: this.contractInfo?.studentFullName,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-lg-3 w-50',
          },
          {
            label: 'Impedimento:',
            data: this.contractInfo?.studentImpediment,
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-lg-3 w-50',
          },
        ],
      ];
    },
    hasStatus() {
      return !this.contractInfo?.contractStatusId;
    },
    contractStatusColor() {
      const statusId = this.contractInfo?.contractStatusId;

      if (!statusId) return rpContractStatusColor[rpContractStatus.New];

      return {
        [rpContractStatus.New]: rpContractStatusColor[rpContractStatus.New],
        [rpContractStatus.Submitted]:
          rpContractStatusColor[rpContractStatus.Submitted],
        [rpContractStatus.Approved]:
          rpContractStatusColor[rpContractStatus.Approved],
        [rpContractStatus.Denied]:
          rpContractStatusColor[rpContractStatus.Denied],
        [rpContractStatus.ApprovedContractInformation]:
          rpContractStatusColor[rpContractStatus.ApprovedContractInformation],
        [rpContractStatus.DeniedContractInformation]:
          rpContractStatusColor[rpContractStatus.DeniedContractInformation],
        [rpContractStatus.Signed]:
          rpContractStatusColor[rpContractStatus.Signed],
        [rpContractStatus.ContractCanceled]:
          rpContractStatusColor[rpContractStatus.ContractCanceled],
        [rpContractStatus.ContractAmended]:
          rpContractStatusColor[rpContractStatus.ContractAmended],
        [rpContractStatus.InSigningProcess]:
          rpContractStatusColor[rpContractStatus.SignatureProcess],
      }[statusId ?? rpContractStatus.Unset];
    },
    contractStatusName() {
      return this.contractInfo?.contractStatusName || 'Nuevo';
    },
  },
};
</script>
